module.exports = require('./lib/i18n-zipcodes.js');
